<template>
    <div>
        <div class="absolute -mt-1 md:-mt-8 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Initial Earnest Money"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="w-full sm:w-36 mt-4 sm:mr-4 sm:my-1">
                <input-money
                    label="Amount Due"
                    name="initial_earnest_money"
                    :value="initial_amount"
                    @input="$emit('updateAmount', $event)"
                    :read_only="read_only"
                />
            </div>

            <div class="w-full sm:w-auto sm:mr-4 mt-4 sm:my-1">
                <input-date
                    label="Date Received"
                    name="initial_earnest_date_received"
                    :value="initial_date_received"
                    @input="$emit('updateDateRecieved', $event)"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:w-auto mt-4 sm:mr-4 sm:my-2">
                <input-radio-boolean
                    class="flex flex-col justify-between h-16"
                    label="Receipt Issued?"
                    name="initial_earnest_receipt"
                    v-model="receipt_issued"
                    true="Yes"
                    false="No"
                    :reverse="true"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <form-row v-if="receipt_issued"
            :no_border="true" class="mb-6"
        >
            <div class="w-full md:w-auto -mt-12 md:-mt-2">
                <input-date
                    label="Receipt Issue Date"
                    name="initial_earnest_receipt_date"
                    :value="deal.initial_earnest_receipt_date"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        initial_amount: {},
        initial_date_received: {},
        read_only: { default: false },
    },

    data() {
        return {
            receipt_issued: this.deal.initial_earnest_receipt,
        }
    },
}
</script>
